import { ApiResponse } from '@/types/apiResponse';
import { apiService } from '../api';

export interface CountryCodes {
  _id: string;
  name: string;
  code: string;
  abbreviation: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

class CommonService {
  private static instance: CommonService;

  private constructor() {}

  public static getInstance(): CommonService {
    if (!CommonService.instance) {
      CommonService.instance = new CommonService();
    }
    return CommonService.instance;
  }

  async getCountryCodes(): Promise<ApiResponse<CountryCodes[]>> {
    return apiService.get<ApiResponse<CountryCodes[]>>(
      'public/api/v1/masterData/getCountryCodes?limit=242&orderBy=asc&sortBy=name',
    );
  }
}

export const commonService = CommonService.getInstance();
